<script setup lang="ts">
export interface Item {
  title: string;
  link?: string;
}

interface Props {
  items: Item[];
}

const props = defineProps<Props>();
</script>

<template>
  <div class="breadcrumbs">
    <div
      v-for="(item, index) in props.items"
      :key="index"
      class="breadcrumbs__item"
    >
      <template v-if="item.link">
        <RouterLink
          v-if="item.title"
          class="breadcrumbs__link"
          :to="item.link"
        >
          {{ item.title }}
        </RouterLink>
        <UiIcon
          name="chevron-right"
          substyle="far"
          color="var(--text-body-secondary)"
          class="t:mx-8"
        />
      </template>
      <span
        v-else
        class="breadcrumbs__inactive-link"
      >
        {{ item.title }}
      </span>
    </div>
  </div>
</template>

<style lang="scss">
.breadcrumbs {
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  font-size: 16px;
  line-height: normal;
  font-weight: 400;
  margin: 16px 0;

  &__item {
    display: flex;
    white-space: nowrap;
  }

  &__link {
    text-decoration: none;
    color: var(--text-link);
  }

  &__inactive-link {
    color: var(--text-body);
    font-weight: 700;
  }
}
</style>
